/*
 * @Author: wjw this.wujiwen@gmail.com
 * @Date: 2023-01-13 11:28:00
 * @LastEditors: zhangweinan
 * @LastEditTime: 2023-03-24 14:20:36
 * @FilePath: \user-center\src\utils\permission.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import storeAccount from '@/config/storeAccount';

export function permission(val) {
  const StoreAccount = storeAccount();
  if (StoreAccount.permissionList.indexOf(val) === -1) {
    return false;
  }
  return true;
}
